import applyPendingUserCapabilityPatches from '@/lib/settings/userCapabilities/applyPendingUserCapabilityPatches.js';
import mergeCapabilityLayers from '@shared/pieve/mergeCapabilityLayers.js';

const buildUserCapabilityVisiblePayload = ({ serverPayload, pendingMutations } = {}) => {
  const currentServerPayload = serverPayload && typeof serverPayload === 'object' ? serverPayload : null;
  const nextCapabilities = applyPendingUserCapabilityPatches({
    capabilities: currentServerPayload?.capabilities || {},
    pendingMutations
  });
  const roleCapabilities = currentServerPayload?.roleCapabilities || {};
  const nextResolvedCapabilities = mergeCapabilityLayers({
    roleBlob: roleCapabilities,
    userBlob: nextCapabilities
  });

  if (!currentServerPayload && Object.keys(nextCapabilities).length < 1) {
    return null;
  }

  return {
    ...(currentServerPayload || {}),
    capabilities: nextCapabilities,
    roleCapabilities,
    resolvedCapabilities: nextResolvedCapabilities
  };
};

export default buildUserCapabilityVisiblePayload;
